import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { GroupsService } from '../../groups/groups.service';
import { map, switchMap } from 'rxjs/operators';
import { GroupMembershipStatus } from '../../groups/models/group-detail.model';
import { of, Observable } from 'rxjs';
import { MembershipBlockedDialogComponent } from '../components/membership-blocked-dialog/membership-blocked-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class MembershipBlockedGuard {
    constructor(
        private auth: AuthService,
        private groupsService: GroupsService,
        private dialog: MatDialog,
        private router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.auth.isLoggedIn()) {
            return this.groupsService.getGroupDetailsPublic(this.auth.idenediGroupId)
                .pipe(switchMap((group) => {
                    // 🚨 Blocked case
                    if (group.GroupMembershipStatus === GroupMembershipStatus.Blocked) {
                        const dialogRef = this.dialog.open(MembershipBlockedDialogComponent, {
                            width: '31.25rem',
                            panelClass: 'rounded-lg',
                        });

                        return dialogRef.afterClosed().pipe(
                            map(() => {
                                if (environment.enableGroupsSelection) {
                                    this.router.navigate(['/groups/choose']);
                                } else {
                                    localStorage.clear();
                                    this.router.navigate(['auth/login']);
                                }

                                return false
                            }) // user clicks OK -> guard resolves false
                        );
                    }

                    return of(true);
                }));
        }

        return Promise.resolve(true);
    }
}
